import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import './index.scss';
// import Editor from './views/random-organic-shapes/Editor';
import Editor from './views/circle-based-organic-shapes/Editor';
import * as serviceWorker from './serviceWorker';

ReactDOM.render((
    <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
            <Editor />
        </QueryParamProvider>
    </Router>
), document.getElementById('root'));

// If you want your App to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
